import { ApolloError } from '@apollo/client';
import { AreaLoader } from '@starrez/starryui';
import React from 'react';
import { ErrorBoundary } from '../Errors/ErrorBoundary';
import { ErrorDisplay } from '../Errors/ErrorDisplay';
import { ModuleLoading } from './ModuleLoading';

interface IGraphQLLoaderProps {
    children: () => React.ReactNode;
    error: ApolloError | undefined;
    loading: boolean;
    loader?: 'local' | 'section';
}

export const GraphQLLoader: React.FC<IGraphQLLoaderProps> = ({ children, error, loading, loader }) => {
    if (loading) return loader === 'local' ? <AreaLoader /> : <ModuleLoading />;
    if (error) return <ErrorDisplay error={error} />;

    return <ErrorBoundary>{children()}</ErrorBoundary>;
};
